import React, { Component } from "react";
import { CSVLink } from "react-csv";
import "../../css/Toogle.css";
import moment from "moment";

const paginate = (array = [], pageSize = 10, pageNumber = 1) => { return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize) }

class StandardTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            processedData: [],
            processedData: null,
            pageNumber: 1,
            totalPage: 0,

            searchInTable: "",
            firstPage: false,
            previousPage: false,
            nextPage: false,
            lastPage: false,

            currentElements: 100,
            sortHeaders: [],
            selectedAll: false,
            selectionList: [],
        };

        this.table = null;
    }

    //#region ComponentBehavior
    componentDidMount() {
        const { searchBar, data } = this.props;
        this.setState({
            searchInTable: searchBar || "",
            totalPage: data.length || 0,
        });
        this.first();
        if (!!searchBar && searchBar !== "") { this.searchInTable(searchBar) } else { this.setState({ processedData: data }); }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.length !== this.props.data.length) { this.searchInTable(this.state.searchInTable); }
    }

    componentWillUnmount() {
        this.table = null
    }
    //#endregion ComponentBehavior

    //#region Search & Order Data
    searchInTable = async (value = "") => {
        const { data, headers } = this.props;
        const columnsToFilter = headers.filter(({ filter }) => filter) || [];

        this.setState({ searchInTable: value, });

        if (value.trim() !== "") {
            let searchTokens = value.toLowerCase().split(" ");
            let searchResult = await data.filter(record => {
                const formattedRow = columnsToFilter.map(({ field }) => record[field]).join(" ");
                let tokens = formattedRow.toLowerCase().split(" ");
                let match = searchTokens.every(token => tokens.some(itemToken => itemToken.includes(token)));
                return match;
            });
            await this.setState({
                currentElements: 100,
                processedData: searchResult,
                totalPage: searchResult.length,
                selectedAll: false,
                selectionList: [],
            });
        } else {
            await this.setState({
                currentElements: 100,
                processedData: null,
                totalPage: data.length,
                selectedAll: false,
                selectionList: [],
            });
        }
        // await this.selectAllAction([], true);
        this.first();
    }

    addSortHeader = (index = -1, field = "", sortHeader = null) => {
        if (index === -1 || !field) return;
        let { sortHeaders } = this.state;

        if (sortHeader) {
            const index = sortHeaders.indexOf(sortHeader);
            if (sortHeader.asc) { sortHeaders[index].asc = false; }
            else { sortHeaders.splice(index, 1); }
        } else { sortHeaders.push({ index, field, asc: true }); }

        this.setState(sortHeaders);
        this.sortData();
    }

    sortData = () => {
        const { sortHeaders } = this.state;
        const { staticRow } = this.props;
        let sortedData = JSON.parse(JSON.stringify(this.props.data));
        let staticRowData = null;
        if (staticRow){
            const index = staticRow === "last" ? sortedData.length - 1 : 0;
            staticRowData = JSON.parse(JSON.stringify(sortedData[index] || ""));
            sortedData.splice(index, 1);
        }

        if (sortHeaders.length) {
            sortedData.sort((a, b) => {
                for (const header of sortHeaders) {
                    if (a[header.field] === b[header.field]) { continue; }

                    if (header.asc) {
                        if (isNaN(a[header.field] || "null")) { return (`${a[header.field] || ""}`).localeCompare(`${b[header.field] || ""}`); }
                        else { return a[header.field] - b[header.field]; }
                    } else {
                        if (isNaN(a[header.field] || "null")) { return (`${b[header.field] || ""}`).localeCompare(`${a[header.field] || ""}`); }
                        else { return b[header.field] - a[header.field]; }
                    }
                }
            });
        }

        if (staticRowData){
            if (staticRow === "last") {
                sortedData.push(staticRowData);
            } else {
                sortedData = [staticRowData].concat(sortedData);
            }
        }

        this.setState({ processedData: sortedData });
    }
    //#endregion Search & Order Data

    //#region Selección multiple
    selectAllAction = async (clean = false) => {
        const { data, idSelection } = this.props;
        const { processedData } = this.state;
        let { selectedAll } = this.state;
        let selectionList = [];
        const cData = processedData ? processedData : data;
        selectedAll = !selectedAll;

        if (clean === true) { selectedAll = false; }

        if (selectedAll) {
            for (const item of cData) {
                selectionList.push(item[idSelection]);
            }
        }

        await this.setState({ selectedAll, selectionList });
    };

    selectOneAction = async (element) => {
        const { data } = this.props;
        const { processedData } = this.state;
        let { selectionList } = this.state;

        const cData = processedData ? processedData : data;
        let selectedAll = false;
        selectionList = selectionList.slice();

        if (!selectionList.find(selected => element === selected)) {
            selectionList.push(element);
            selectedAll = selectionList.length === cData.length;
        } else { selectionList = selectionList.filter(selected => element !== selected); }

        await this.setState({ selectedAll, selectionList });
    };
    //#endregion

    //#region Navigation
    changePageSize = async (value) => {
        await this.setState({ pageSize: value });
        this.first();
    }

    first = () => {
        const { data } = this.props;
        const { processedData, pageSize } = this.state;
        const totalPage = processedData ? processedData.length : data.length;

        this.setState({
            pageNumber: 1,
            firstPage: false,
            previousPage: false,
            nextPage: Number(totalPage || 0) / Number(pageSize || 10) > 1,
            lastPage: Number(totalPage || 0) / Number(pageSize || 10) > 1,
        });
    }

    previous = () => {
        const pageNumber = Number(this.state.pageNumber) - 1;

        this.setState({
            pageNumber: pageNumber,
            firstPage: pageNumber > 1,
            previousPage: pageNumber > 1,
            nextPage: true,
            lastPage: true,
        });
    }

    next = () => {
        const { data } = this.props;
        const { processedData, pageSize } = this.state;
        const totalPage = processedData ? processedData.length : data.length;

        let last = Math.ceil(Number(totalPage || 0) / Number(pageSize || 10));
        const pageNumber = Number(this.state.pageNumber) + 1;

        this.setState({
            pageNumber: pageNumber,
            firstPage: true,
            previousPage: true,
            nextPage: pageNumber < last,
            lastPage: pageNumber < last,
        });
    }

    last = () => {
        const { data } = this.props;
        const { processedData, pageSize } = this.state;
        const totalPage = processedData ? processedData.length : data.length;

        let last = Math.ceil(Number(totalPage || 0) / Number(pageSize || 10));
        this.setState({
            pageNumber: last,
            firstPage: true,
            previousPage: true,
            nextPage: false,
            lastPage: false,
        });
    }

    showMoreAction = () => {
        let { currentElements } = this.state;
        this.setState({ currentElements: currentElements + 100 })
    }

    showLessAction = () => {
        let { currentElements } = this.state;
        this.setState({ currentElements: currentElements - 100 })
    }
    //#endregion Navigation

    //#region Render Component
    render() {
        const {
            headers,
            data,
            paginated = true,
            searchBarSize,
            filename,
            maxHeight,
        } = this.props;

        const {
            processedData,
            pageNumber,
            searchInTable,
            totalPage,
            firstPage,
            previousPage,
            nextPage,
            lastPage,
            currentElements,
            pageSize,
        } = this.state;

        const firstElement = ((pageNumber - 1) * (pageSize || 10)) + 1;
        const lastElement = (pageNumber * (pageSize || 10));

        const dataToShow = paginate(processedData || data, paginated ? pageSize : currentElements, paginated ? pageNumber : 1);

        const csvHeaders = headers.filter(({ exportCSV }) => !!exportCSV);
        const showCSVButton = !!(Array.isArray(csvHeaders) && csvHeaders?.length) && !!(Array.isArray(processedData || data) && (processedData || data)?.length);

        return (
            <div>
                <div className="search-div row">
                    {searchBarSize !== "none" &&
                        <div className={`col-${searchBarSize === "sm" ? "3" : searchBarSize === "md" ? "6" : searchBarSize === "lg" ? "9" : "12"}`} style={{ width: "100%" }}>
                            <input
                                id="searchStandardDataTable"
                                className="form-control btn-outline-secondary dropdown-toggle listSerie hide-pc"
                                style={{ display: "inline-flex" }}
                                placeholder="Buscar"
                                autoComplete="off"
                                type="text"
                                value={searchInTable || ""}
                                onChange={(ev) => this.searchInTable(ev.target.value)} />
                        </div>
                    }

                    {showCSVButton && (
                        <div className="col-4 col-lg-2 mb-3 text-right ml-auto">
                            <CSVLink
                                className="btn btn-success"
                                filename={`${filename || ""} ${moment().format("YYYY-MM-DD")}`}
                                headers={csvHeaders.map(({ title, field }) => ({ label: title, key: field }))}
                                data={(processedData || data).map((rowInfo) => {
                                    let newRow = {};
                                    csvHeaders.forEach(({ field, format }) => newRow[field] = !!format ? format(rowInfo[field], rowInfo) : (rowInfo[field] || ""));
                                    return newRow;
                                })} >
                                Exportar CSV
                            </CSVLink>
                        </div>
                    )}
                </div>

                <div className="w-100 table-scroll table standard-table" style={maxHeight ? { maxHeight, overflow: "auto" } : {}}>
                    {this.renderTable(dataToShow)}
                </div>

                <div className="navigation-tabs" style={{ textAlign: "right" }}>
                    {paginated && dataToShow.length ?
                        <div className="d-flex">
                            <div>
                                <label className="col-form-label col-form-label-sm mr-2"> Rgistros por pagina: </label>
                                <select
                                    className="col-form-label col-form-label-sm"
                                    value={pageSize}
                                    onChange={({ target: { value } }) => { this.changePageSize(value); } }>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                            <label className="ml-auto mt-1"> {firstElement} - {lastElement > totalPage ? totalPage : lastElement} de {totalPage} </label>
                            <div>
                                <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Primera" onClick={this.first} disabled={!firstPage}>
                                    <i className="fas fa-chevron-left btn-first" />
                                </button>
                                <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Anterior" onClick={this.previous} disabled={!previousPage}>
                                    <i className="fas fa-chevron-left" />
                                </button>
                                <label htmlFor="colFormLabelSm" className="col-form-label col-form-label-sm"> {pageNumber} </label>
                                <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Siguiente" onClick={this.next} disabled={!nextPage}>
                                    <i className="fas fa-chevron-right" />
                                </button>
                                <button className="btn btn-link btn-sm text-dark" data-toggle="tooltip" data-placement="top" title="Última" onClick={this.last} disabled={!lastPage}>
                                    <i className="fas fa-chevron-right btn-last" />
                                </button>
                            </div>
                        </div>
                        :
                        <div>
                            <label className="col-form-label col-form-label-sm"> Elementos encontrados: {totalPage} </label>
                        </div>
                    }
                </div>
            </div>
        );
    }

    renderTable(data) {
        const {
            id,
            headers,
            actPos,
            openDetails,
            selectMode,
            selectAction,
            paginated = true,
            idSelection,
        } = this.props;

        const {
            selectedAll,
            processedData,
            selectionList,
            sortHeaders,
            currentElements,
        } = this.state;

        const columns = headers.filter(({ active }) => active) || [];
        const headerAction = (selectMode || selectAction) ? (<td className="text-center"> {selectMode === "multiple" ? <input type="checkbox" checked={selectedAll} onChange={this.selectAllAction} /> : ""} </td>) : null;
        
        const enableShowMore = currentElements < processedData?.length;
        const enableShowLess = currentElements > 100;

        let header = "";
        if (columns.length > 0) {
            header =
                <tr className="table-header-yellow">
                    {actPos === "start" && headerAction}
                    {columns.map((column, index) => {
                        const sortable = column.sortable;
                        const sortHeader = sortHeaders?.find(header => header.index === index);
                        return (<td key={index} style={{ cursor: sortable ? "pointer" : "" }} onClick={() => { if(sortable) { this.addSortHeader(index, column.field, sortHeader); } }}> {column.title || ""} {sortHeader ? (sortHeader.asc ? <i className="fa fa-caret-up"/> : <i className="fa fa-caret-down"/>) : ""} </td>);
                    })}
                    {openDetails && <td className="text-center"> Acciones </td>}
                    {actPos !== "start" && headerAction}
                </tr>;
        }

        const colSpan = (columns.length + 1 || 1) + (openDetails ? 1 : 0);

        let body =
            <tr key="0">
                <td className="text-center dt-row-primary" colSpan={colSpan}>
                    No hay información para mostrar
                </td>
            </tr>;

        if (Array.isArray(data)) {
            if (data.length) {
                body = (<>
                    {data.map((register, index) => {
                        const checked = Array.isArray(selectionList) ? selectionList.find(element => element === register[idSelection]) : false;
                        const rowAction = (selectMode || selectAction) ? (
                            <td className={`text-center dt-row-${index % 2 ? "secondary" : "primary"}`} key={`col-Action-${index}`}>
                                {selectMode === "multiple" ?
                                    <input
                                        type="checkbox"
                                        checked={checked}
                                        onChange={() => this.selectOneAction(register[idSelection], data, checked)} />
                                    :
                                    <button type="button" className="btn btn-warning-outline" onClick={() => selectAction(register)}> <i className="fas fa-check" /> </button>
                                }
                            </td>)
                            : null;

                        const row =  (
                            <tr key={index}>
                                {actPos === "start" && rowAction}
                                {columns.map((column, subindex) => <td className={`dt-row-${index % 2 ? "secondary" : "primary"}-light ${column.classes || ""}`} key={`col-${column.field}-${index}-${subindex}`}>{column.format ? column.format(register[column.field] || "", register, index) : register[column.field] || ""}</td>)}
                                {openDetails &&
                                    <td className={`text-center dt-row-${index % 2 ? "secondary" : "primary"}`} key={`col-Details-${index}`}>
                                        <button type="button" className="btn btn-warning" onClick={() => openDetails(register)}><i class="far fa-file-alt" /> Ver Detalles </button>
                                    </td>
                                }
                                {actPos !== "start" && rowAction}
                            </tr>
                        )
                        return row;
                    })}
                    {!paginated && (enableShowMore || enableShowLess) &&
                        <tr key="row-noPaginated">
                            <td key="col-noPAginated" className="container dt-row-primary" colSpan={colSpan}>
                                <div className="row">
                                    {enableShowMore && <div className="col-3"> <button className="border-0" onClick={this.showMoreAction}><i className="fa fa-chevron-down" /> Mostrar más </button> </div>}
                                    {enableShowLess && <div className="col-3"> <button className="border-0" onClick={this.showLessAction}><i className="fa fa-chevron-up" /> Mostrar menos </button> </div>}
                                </div>
                            </td>
                        </tr>
                    }
                </>);
            }
        }

        return (
            <table id={id}>
                <thead className="table-header ">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        );
    }
    //#endregion Render Component
}
export default StandardTable;